export default __webpack_public_path__ + "static/media/M2POP.5e64d4aa.jpg";